import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localesDE from '../locales/de'
import localesEN from '../locales/en'
import localesFR from '../locales/fr'
import localesIT from '../locales/it'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'de-DE',
  fallbackLocale: 'de-DE',
  messages: {
    'de-DE': localesDE,
    'en-EN': localesEN,
    'fr-FR': localesFR,
    'it-IT': localesIT,
  },
})

/*
i18n with vue:
https://medium.com/hypefactors/add-i18n-and-manage-translations-of-a-vue-js-powered-website-73b4511ca69c

Language selection example:
<div class="locale-changer">
  <select v-model="$i18n.locale">
    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
  </select>
</div>

...
data() {
  return {
    langs: [ 'de-DE', 'fr-FR' ],
  }
}
*/
